import React from 'react';

import {Helmet} from 'views/module';

import ClientListScene from 'views/scenes/client/list/ClientList';

const ClientList = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <ClientListScene
      />
    </>
  );
};

export default ClientList;
